import React from 'react';
import {
  AnalyticsIcon,
  HostingIcon,
  MonetizationIcon,
  RecordIcon,
} from '../../../screens/FeaturesScreen/components/SubNavigation/SubNavigationSvgs';

const SIGNED_OUT_LINKS = [
  {
    label: 'FEATURES',
    key: 'features',
    to: '/features',
    subLinks: [
      {
        to: '/features',
        svg: <RecordIcon color="#292f36" />,
        label: 'Easy-to-use creation tools',
        description:
          'Creation tools designed for every podcast, at every level. ',
        key: 'overview',
        ariaLabel: 'link to creation tools section on feature page',
      },
      {
        to: '/features#hosting',
        anchorId: 'hosting',
        svg: <HostingIcon color="#292f36" />,
        label: 'Hosting & distribution',
        description:
          '100% free hosting and one-click distribution so you can focus on creating your podcast.',
        ariaLabel: 'link to hosting section on feature page',
      },
      {
        to: '/features#analytics',
        anchorId: 'analytics',
        svg: <AnalyticsIcon color="#292f36" />,
        label: 'Straightforward analytics',
        description:
          'Convenient stats to help you track your podcast’s performance',
        ariaLabel: 'link to analytics section on feature page',
      },
      {
        to: '/features#sponsorships',
        anchorId: 'sponsorships',
        svg: <MonetizationIcon color="#292f36" />,
        label: 'Get paid to podcast',
        description: 'The first podcast advertising platform for everyone.',
        ariaLabel: 'link to sponsorships section on feature page',
      },
    ],
  },
  {
    label: 'SWITCH TO ANCHOR',
    key: 'switch',
    to: '/switch',
  },
  {
    label: 'BLOG',
    key: 'blog',
    href: 'https://blog.anchor.fm',
    openInNewTab: true,
  },
];

// TODO: add back episodes link when the episodes page is ready
const SIGNED_IN_LINKS = [
  {
    label: 'NETWORK',
    key: 'network',
    to: '/dashboard/network',
  },
  {
    label: 'DASHBOARD',
    key: 'dashboard',
    to: '/dashboard',
  },
  {
    label: 'EPISODES',
    key: 'episodes',
    to: '/dashboard/episodes',
  },
  {
    label: 'MONEY',
    key: 'money',
    to: '/dashboard/money',
    notificationBadge: 'DollarSignIcon',
  },
];

const ACCOUNT_MENU_ITEMS = [
  {
    label: 'Update settings',
    icon: {
      type: 'GearIcon',
      iconColor: '#c9cbcd',
      backgroundColor: 'transparent',
      width: 18,
      padding: 0,
    },
    to: '/dashboard/podcast/edit',
  },
  {
    label: 'Help',
    icon: {
      type: 'QuestionMarkIcon',
      iconColor: '#ffffff',
      backgroundColor: 'gray',
      width: 18,
      padding: 3,
    },
    target: '_blank',
    href: 'https://help.anchor.fm/',
  },
];

export { SIGNED_OUT_LINKS, SIGNED_IN_LINKS, ACCOUNT_MENU_ITEMS };
